import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgDownloadDocumentFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#download-document-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M0 28.001a28.015 28.015 0 0 1 56.03 0H0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "m12.899 10.045 34.415 2.513-2.945 40.346-34.416-2.512z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m16.156 12.328 27.972 2.043-.568 13.567c-.298 4.437-1.21 15.434.155 19.656-11.639.68-18.937-.184-30.126-.87z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#244A6C",
        fillRule: "evenodd",
        d: "M36.542 7.618a5.9 5.9 0 0 1-.449 1.873l5.81.424a.965.965 0 0 1 .892 1.033l-.322 4.401a.965.965 0 0 1-1.032.892l-22.825-1.666a.965.965 0 0 1-.893-1.033l.322-4.401a.965.965 0 0 1 1.032-.892l5.809.424a5.93 5.93 0 1 1 11.656-1.054m-6.106 2.156a2.594 2.594 0 1 0 .378-5.175 2.594 2.594 0 0 0-.378 5.175",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 28.074,
        cy: 44.182,
        r: 9.994,
        fill: "#4C875B"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M29.193 44.857v-5.713h-2.386v5.713l-1.685-1.684-1.687 1.687 2.878 2.877L28 49.425l1.688-1.687 2.877-2.879-1.687-1.687z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `download-document-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgDownloadDocumentFidelityLow;
